import React from "react";
import ReactDOM from "react-dom";
import { Route, Switch, Redirect, HashRouter } from "react-router-dom";
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';
import { GuardProvider, GuardedRoute } from 'react-router-guards';
import Login from "views/Login";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "assets/scss/paper-dashboard.scss?v=1.2.0";
import "assets/demo/demo.css";
import "assets/css/styles.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import AdminLayout from "layouts/Admin.js";

const requireLogin = (to, from, next) => {
	if (to.meta.auth) {
		if (localStorage.user) {
			next();
		}
		next.redirect('/login');
	} else {
		next();
	}
};

ReactDOM.render(
	<>
		<ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />
		<HashRouter>
			<GuardProvider guards={[requireLogin]} loading={null} error={Login}>
				<Switch>
					<GuardedRoute path="/admin" component={AdminLayout} meta={{ auth: true }} />
					<Route path="/login" component={Login} />
					<Route
						exact
						path="/"
						render={() => {
							return localStorage.user ? (
								<Redirect to="/admin" />
								) : (
									<Redirect to="/login" />
								);
						}}
					/>
					<GuardedRoute path="*" component={Login} />
				</Switch>
			</GuardProvider>
		</HashRouter>
	</>,
	document.getElementById("root")
);
